import { useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { RequestStatusDisplay } from '../CommonComponents';
import { Anchor, Input } from "../RequestRespectingInputs";
import { Button } from "../RequestRespectingInputs";
import { GetPageTitle } from '../../ErnotsConfig';
import { RequestStatus } from '../../api_request/api_request';
import { sendLogin } from './data';

export function LoginForm()
{
    const appDispatch = useAppDispatch();
    const loginState = useAppSelector((state) => state.login);
    const [request, setRequest] = useState<RequestStatus|undefined>(undefined);

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    var contents = <></>;
    if (request?.success && loginState.currentUser.username)
    {
        contents =
        <p>
            Welcome, <Anchor to={`/user/settings`}>{loginState.currentUser.username}</Anchor>            
        </p>;
    }
    else
    {
        contents = 
        <form id='loginForm' autoComplete="on" onSubmit={
            async function(event)
            {
                event.preventDefault();
                await sendLogin(username, password, appDispatch, setRequest);
            }}>

            <h2>Log on in!</h2>
            <table border={1}>
                <tbody>
                    <tr>
                        <td><b>User Name/Email</b></td>
                        <td>
                            <Input
                                id='username'
                                type='text'
                                required
                                autoComplete='username'
                                value={username}
                                onChange={(e) => setUsername(e.target.value)} />
                        </td>
                    </tr>
                    <tr>
                        <td><b>Password</b></td>
                        <td>
                            <Input
                                type='password'
                                required
                                autoComplete='current-password'
                                value={password}
                                onChange={(e) => setPassword(e.target.value)} />
                        </td>
                    </tr>
                </tbody>
            </table>
            <Button type='submit'>Log In</Button>
            <RequestStatusDisplay request={request}/>
            <p>
                <Anchor to={`/user/password-reset-request`}>Reset password</Anchor>
                &nbsp;
                <Anchor to={`/user/resend-activation-email`}>Resend Activation Email</Anchor>
            </p>
        </form>;
    }

    return (
    <>
        <title>{GetPageTitle('Login')}</title>
        <fieldset>{contents}</fieldset>
    </>);
}